import { Link as RemixLink } from 'react-router';

import useEnv from '~/hooks/useEnv';

type Props = {
  children: React.ReactNode;
  className?: string;
  external?: boolean;
  onClick?: React.MouseEventHandler<HTMLAnchorElement>;
  to: string;
};

function ReactAppLink({ to, children, ...props }: Props) {
  const { SITE_BASE_URL } = useEnv();

  const url = new URL(to, SITE_BASE_URL);

  return (
    <a href={url.href} {...props}>
      {children}
    </a>
  );
}

export default function Link({ to, children, external, ...props }: Props) {
  return external ? (
    <ReactAppLink to={to} {...props}>
      {children}
    </ReactAppLink>
  ) : (
    <RemixLink to={to} {...props}>
      {children}
    </RemixLink>
  );
}
